import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";
import apiRequestType from "../apiRequestType";

const getAllVariantLanguages = () => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.MANAGE.GET_ALL_VARIANT_LANGUAGES
  );
};

export default getAllVariantLanguages;
